import { useState } from "react";
import { apiFetch } from "../../../context/AuthContext";

// Backend-only in Phase 1 per the original plan; the endpoint
// (`GET /todos/:id/history`) was added specifically so this panel isn't
// blocked once built — see TASK_ASSIGNMENT_FEATURE_PLAN.md §4.2b. Lazy:
// only fetched when TaskDetailModal actually opens for a given task.
const useTaskHistory = (BASE_URL) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchHistory = async (taskId) => {
    if (!taskId) return;
    setLoading(true);
    setError(null);
    try {
      const response = await apiFetch(`${BASE_URL}/todos/${taskId}/history`, { method: "GET" });
      const data = await response.json();
      if (!response.ok || data.success === false) {
        throw new Error(data.error || "Failed to load history");
      }
      setHistory(data.history || []);
    } catch (err) {
      console.error("Error fetching task history:", err);
      setError(err.message);
      setHistory([]);
    } finally {
      setLoading(false);
    }
  };

  const resetHistory = () => {
    setHistory([]);
    setError(null);
  };

  return { history, loading, error, fetchHistory, resetHistory };
};

export default useTaskHistory;
